import type { UpdateEventRequest } from '@pulsify/shared/dto'
import type { CreateEventInput } from '~/shared/types'

type AudienceFields = Pick<
  Partial<CreateEventInput>,
  'plusOnesMax' | 'minAge' | 'studentsOnly' | 'audienceNote' | 'targetAgeMin' | 'targetAgeMax'
>

type AudiencePayload = Pick<
  UpdateEventRequest,
  'plusOnesMax' | 'minAge' | 'studentsOnly' | 'audienceNote' | 'targetAgeMin' | 'targetAgeMax'
>

/** The audience settings the form holds, as the API takes them; an emptied field clears it. */
export function audiencePayload(data: AudienceFields): AudiencePayload {
  const payload: AudiencePayload = {}
  if (data.plusOnesMax !== undefined) payload.plusOnesMax = data.plusOnesMax
  if (data.minAge !== undefined) payload.minAge = data.minAge
  if (data.studentsOnly !== undefined) payload.studentsOnly = data.studentsOnly
  if ('audienceNote' in data) payload.audienceNote = data.audienceNote?.trim() || null
  if ('targetAgeMin' in data) payload.targetAgeMin = data.targetAgeMin ?? null
  if ('targetAgeMax' in data) payload.targetAgeMax = data.targetAgeMax ?? null
  return payload
}
